import { uploadEntityAttachments, deleteAttachment, fetchEntityAttachments } from '@/lib/entity-attachments';

export interface ProposalFileAttachment {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_url: string;
  created_at: string;
  created_by: string;
  created_by_user?: {
    display_name?: string | null;
  };
}

/**
 * Fetches a proposal's attachments through the API (rows, uploader names and signed URLs in one request). Kept separate from
 * signProposalAttachments (which now only signs what is still a raw Storage path) so a caller can render
 * filenames/dates (Version History, the attachment list) the instant this
 * resolves, without waiting for every attachment's signed URL too --
 * signing is a separate, slower network round-trip per file that the
 * caller can now do lazily/in the background instead of blocking on.
 */
export async function fetchProposalAttachmentRows(proposalId: string): Promise<ProposalFileAttachment[]> {
  // Through the API: the rows with their uploader's name and their permanent KrewUp address, newest first.
  return fetchEntityAttachments('proposal', proposalId, { ascending: false });
}

export async function uploadProposalAttachments(
  proposalId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<ProposalFileAttachment[]> {
  return uploadEntityAttachments('proposal', proposalId, files, companyId, userId);
}

export function deleteProposalAttachment(
  attachmentId: string,
  userId: string | undefined
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}

